import { Button, Grid, Select, MenuItem, TextField } from "@material-ui/core";
import { useSelector, useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { Controller, useForm } from "react-hook-form";
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { makeStyles } from '@material-ui/core/styles';
import { getAllTransactions } from '../../../store/constructs/transactions/selectors';
import UpdateEventAlert from '../../molecules/alerts/UpdateEventAlert'
import { handleSnackBar } from '../../../store/global/actions';
import { getDetailsFromUrl } from '../../../services/blueprint';
import { invokePostService, invokeGetService, setReRender, setFocusElement, toggleRightDrawer } from "../../../store/global/actions";
import {  useParams } from 'react-router-dom';
import SkeletonLoader from "../../atoms/loader/SkeletonLoader";


const useStyles = makeStyles({
    button: {
        height: 53,
        marginLeft: 10
    }
})
export default function AdvancedSetup({ element, onCompletion, onCancel, handleUpdateInDiagram }) {
    const dispatch = useDispatch();
    const params = useParams();

    const [dataLoading, setDataLoading] = useState(false);
    const [conditionMandatory, setConditionMandatory] = useState(false);
    const [alertDialog, setAlertDialog] = useState(false);
    const [clusterlets, setClusterlets] = useState([]);
    const [selectedEvent, setSelectdEvent] = useState(element.item)
    const [action, setAction] = useState({});
    const [isUpdating, setIsUpdating] = useState(false);

    const allTransactionsList = useSelector(getAllTransactions);

    
    const [loading, setLoading] = useState(true)
    const { entityId } = getDetailsFromUrl();


    const {condition, src, dst, timeout, validation, key, context } = selectedEvent || {};


    const getClusterlet = (id) => {
        const clusterlet = clusterlets.find(clusterlet => clusterlet._id === id)
        return clusterlet;
    }

    const { register, handleSubmit, formState: { errors }, setValue, control, reset, watch, getValues, setError } = useForm({});

    useEffect(() => {
        setDataLoading(true)
        getInitialData().then(([associatedData, constructs]) => {

            if (associatedData.status) {
                setClusterlets(associatedData.data.clusterlets || []);
                setSelectdEvent(associatedData?.data?.event || [])
                setDataLoading(false)

            }else if (associatedData?.status === false && associatedData?.code === 255) {
                dispatch(toggleRightDrawer());
                dispatch(setReRender());

            }

            setLoading(false);

        }).catch(error => {
            console.error(  "Error fetching initial data:", error);
        })

    }, [])


    const getInitialData = async () => {
        return await Promise.all([
            dispatch(invokeGetService('getEventAssociatedData', [element.id, entityId])),
            // dispatch(invokeGetService('getBlueprintConstructs', {}))
        ])
    }
    
    useEffect(() => {
        reset({
            condition,
            timeout,
            key,
            context,
            validate: validation,
        })
    }, [selectedEvent])


    useEffect(() => {
        const eventTransaction = allTransactionsList.find(item => {
            const events = item.events.map(item => item.id)
            if (events.includes(element.id)) return item;
        })

        if (eventTransaction?.type === 9 && eventTransaction?.oneof) setConditionMandatory(true)
    }, [element])

    const srcNode = getClusterlet(src);
    const dstNode = getClusterlet(dst);

    let protocol = srcNode?.type === 1 ? srcNode?.attributes?.type : dstNode?.type === 1 ? dstNode?.attributes?.type : undefined;

    const formatEvent = (event) => {

        let newEvent = {
            name: selectedEvent?.name,
            desc: selectedEvent?.desc,
            message: selectedEvent?.message,
            attributes: selectedEvent?.attributes,
            src: selectedEvent?.src,
            dst: selectedEvent?.dst,
            type: 8,
            isError: event?.error_resp_event ? true : false,
            condition: event?.condition || "",
            validate:(!event.validate || event.validate === "") ? 'none' : event.validate,
            timeout: event.timeout,
            key: event.key,
            context: event.context
        }

        if (event.condition !== '' && event.condition !== undefined)
            newEvent.condition = event.condition;

        if (event.instance !== '' && event.instance !== undefined)
            newEvent.instance = event.instance

        return newEvent
    }

    const onUpdate = (eventData) => {
        setIsUpdating(true);
        let gotoEventType = false;
        let newEvent = formatEvent(eventData);

        // if(handleUpdateInDiagram) handleUpdateInDiagram({id: element?.id, type: "event", data: newEvent});


        const payload = { 
            event: newEvent, 
            selectedEvent: selectedEvent, 
            selectedTransactionId: params?.transaction, 
            messageData: null 
        }

        dispatch(invokePostService('updateEvent', payload, [element.id]))
            .then(savedData => {
                if (savedData.status) {
                    dispatch(setReRender());
                    onCompletion(savedData?.data, 'edit', gotoEventType, protocol);
                } else {
                    if ( savedData?.code === "600") {
                        savedData?.errors?.forEach(error => {
                            setError(error.name, {message: error.message});
                        });
                    } else if (savedData?.message) {
                        dispatch(handleSnackBar({ open: true, message: savedData.message, severity: "error" }));
                    }
                }
                setIsUpdating(false);
            })


    }

    return (
        <>
        {
            loading ? 
             <SkeletonLoader type="form" rows={3} grid={[1,2,1]} />
            :
            <>
            <Grid container direction={"row"} spacing={3} style={{marginBottom: 20}}>

                {/* Condition */}
                <Grid item xs={12} >
                    <TextField
                        defaultValue={condition}
                        name="condition"
                        type={"text"}
                        InputLabelProps={{shrink: true}}
                        fullWidth
                        // required={conditionMandatory}
                        label={"Condition"}
                        variant="outlined"
                        inputRef={register({ required: conditionMandatory, })}
                        error={errors?.condition ? true : false}
                        helperText={Boolean(errors.condition) ? <div style={{ color: "red" }}> Condition cannot be empty </div> : ""}
                    />
                </Grid>

                <Grid item xs={6}>
                    <Controller
                        name="validate"
                        control={control}
                        render={({ field, value, onChange }) =>
                            <TextField
                                name="validate"
                                {...field}
                                label={"Validation"}
                                fullWidth
                                value={value}
                                select
                                variant="outlined"
                                onChange={e => { onChange(e)}}
                            >
                                <MenuItem key={1} value={"none"}>None</MenuItem>
                                <MenuItem value="send">Before Send</MenuItem>
                                <MenuItem value="recv">Before Recieve</MenuItem>
                                <MenuItem value="both">Both</MenuItem>
                            </TextField>
                        }
                    />
                </Grid>

                {/* <Grid item xs={6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        type={"text"}
                        name={"timeout"}
                        fullWidth
                        label={"Timeout"}
                        variant="outlined"
                        inputRef={register()}
                        placeholder="In milliseconds"
                        defaultValue={''}
                    />
                </Grid> */}

                <Grid item xs={6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        type={"text"}
                        name={"key"}
                        fullWidth
                        label={"Load Balance Key"}
                        variant="outlined"
                        inputRef={register()}
                        defaultValue={''}
                    />

                </Grid>

                <Grid item xs={12}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        type={"text"}
                        name={"context"}
                        fullWidth
                        label={"Load Balance Context"}
                        variant="outlined"
                        disabled={!watch('key') || watch('key') === "" ? true : false}
                        inputRef={register()}
                        defaultValue={''}
                    />

                </Grid>

                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                    <UpdateCancel onUpdate={handleSubmit(onUpdate)} content={isUpdating ? 'Updating..' : 'Update'} onCancel={onCancel} updateDisable={action?.action === 'create_message' || dataLoading || isUpdating ? true : false} typesNotIn={['transaction', 'view']} />
                </Grid>

            </Grid>

            {alertDialog === true && <UpdateEventAlert onCompletion={handleSubmit(onUpdate)} eventId={element.id} showAlert={setAlertDialog} typesNotIn={['transaction', 'view']} />}

            </>
        }
        </>
    )

}